import React, { useState, useEffect } from "react";
// APIモジュール
import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "../graphql/queries";

import {
  TextField,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  IconButton,
} from "@material-ui/core";
import { StyledTableCell, StyledTableRow } from "../modules/modules";
import SendIcon from "@material-ui/icons/Send";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  textField: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
}));

// 受注情報のヘッダー情報
const columns = [
  { id: "name", minWidth: 0, type: "text" },
  { id: "key", minWidth: "50vw", type: "text" },
];

// ■■■■■■■■■■■■■■■■■■
// list
// ■■■■■■■■■■■■■■■■■■
export default function Color(props) {
  const handleUpdateGraphql = props.handleUpdateGraphql;
  const classes = useStyles();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    // ユーザーリスト取得
    listColors().then((response) => {
      var user_list_row = response.map((item) => {
        // 行を各列で整形
        var row = {};
        columns.forEach((col) => {
          row[col["id"]] = (
            <form
              onSubmit={(values) => {
                handleUpdateGraphql("updateColor", values);
              }}
            >
              <TextField
                className={classes.textField}
                name={item["id"]}
                type={col["type"]}
                label={col["id"]}
                defaultValue={item[col["id"]]}
              />
              <IconButton color="secondary" type="submit">
                <SendIcon />
              </IconButton>
            </form>
          );
        });
        return row;
      });
      setRows(user_list_row);
    });
  }, []);

  const listColors = function () {
    return new Promise(function (resolve, reject) {
      // ユーザーリスト取得
      API.graphql(
        graphqlOperation(queries.listColors, {
          limit: 20,
        })
      )
        .then((response) => {
          resolve(response.data.listColors.items);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return (
    <React.StrictMode>
      <TableContainer>
        <Table className={classes.table} stickyHeader>
          <TableHead>
            <StyledTableRow>
              {columns.map((column) => (
                <StyledTableCell key={column.id}>{column.id}</StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              return (
                <StyledTableRow key={row["id"]}>
                  {columns.map((column) => {
                    return (
                      <StyledTableCell
                        key={column.id}
                        style={{ minWidth: column.minWidth }}
                      >
                        {row[column.id]}
                      </StyledTableCell>
                    );
                  })}
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </React.StrictMode>
  );
}
